

import axios from 'axios';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import styles from './Form.module.css';
import * as yup from 'yup';

const FormPage =()=>{
  const defaultLink = 'http://iasasc.centralindia.cloudapp.azure.com:8082/api/'

    const validationSchema = yup.object().shape({
      name: yup.string().required('Name is required'),
        email: yup.string().email('Invalid email').required('Email is required'),
        subject: yup.string().required('Subject is required'),
        message: yup.string().required('Message is required'),
    })

    return(
        <Formik
            initialValues={{ email: '', name: '', subject:'', message:'' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {

                    const data={
                        "sender_name": values.name,
                        "sender_email": values.email,
                        "subject": values.subject,
                        "message_text": values.message
                    }

                    axios.post(defaultLink + 'messages', JSON.stringify(data))
                    setSubmitting(false);
                }, 400);
            }}
        >
            {({ isSubmitting }) => (
                <Form className='z-20 relative'>
                    <div className='flex justify-between'>
                        <div className='w-5/12'>
                            <Field type="text" name="name" placeholder='Name' className={styles.field}/>
                            <ErrorMessage name="name" component="div" className={styles.error} />
                        </div>
                        <div className='w-5/12'>
                            <Field type="email" name="email" placeholder='Email' className={styles.field}/>
                            <ErrorMessage name="email" component="div" className={styles.error}/>
                        </div>
                    </div>
                    <div>
                        <Field type="text" name="subject"  placeholder='Subject' className={styles.field}/>
                        <ErrorMessage name="subject" component="div" className={styles.error}/>
                    </div>
                    <div>
                        <Field as='textarea'   rows={4} cols={50} name="message" placeholder='Message' className={`${styles.field} h-40`}/>
                        <ErrorMessage name="message" component="div" className={styles.error}/>
                    </div>
                    <button type="submit" disabled={isSubmitting} className={styles.submitButton}>
                        Submit
                    </button>
                </Form>
            )}
        </Formik>
    )
}

export default FormPage;